import type { ETabletPattern } from "../../../core/ETabletPattern";
import { DrawCabinetInsideElement } from "./DrawCabinetInsideElement";


export class DrawInsideTablet extends DrawCabinetInsideElement {
    Pattern!: ETabletPattern;
}
